module.exports = __webpack_public_path__ + "img/abr_en.d88570f.jpg";